<template>
    <b-modal
        v-model="mostrarModalLocal"
        @show="preencherModal()"
        @hidden="fecharModal()"
        size="xl"
        no-close-on-backdrop
    >
        <div slot="modal-title">{{ titulo }}</div>
        <h5 class="heading-1 mb-4">
            <span>ITENS DA REQUISIÇÃO - SELECIONADOS</span>
        </h5>
        <b-row>
            <b-col sm="12">
                <app-tabela
                    :itens="itensSelecionados"
                    :campos="campos2"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="true"
                >
                    <template slot="valorUnitario" slot-scope="data">{{
                        data.valorUnitario | currency
                    }}</template>
                    <template slot="quantidade" slot-scope="data">{{
                        data.quantidade | currency2
                    }}</template>
                    <template slot="subTotal" slot-scope="data">{{
                        data.subTotal | currency
                    }}</template>
                    <template slot="desconto" slot-scope="data">{{
                        data.desconto | currency
                    }}</template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                    <template slot="totalRateado" slot-scope="data">{{
                        data.totalRateado | currency
                    }}</template>
                    <template slot="saldoASerRateado" slot-scope="data">{{
                        data.saldoASerRateado | currency
                    }}</template>
                    <template slot="valorRateado" slot-scope="data">{{
                        data.valorRateado | currency
                    }}</template>
                </app-tabela>
            </b-col>
        </b-row>
        <h5 class="heading-1 mb-4">
            <span>DADOS GERAIS</span>
        </h5>
        <b-row>
            <b-col sm="12" md="9">
                <b-form-group>
                    <label class="required">Histórico Comprometimento</label>
                    <b-form-textarea
                        v-model="historicoComprometimento"
                        :rows="4"
                        :disabled="operacao == 'D'"
                    ></b-form-textarea>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label class="required">Data do Comprometimento</label>
                    <date-picker
                        v-model="dataComprometimento"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        :disabled="operacao == 'D'"
                    ></date-picker>
                </b-form-group>
            </b-col>
        </b-row>
        <h5 class="heading-1 mb-4">
            <span>RATEIO</span>
        </h5>
        <quadro-resumo-rateios-edicao
            :itensSelecionados="itensSelecionados"
            :rateios="rateios"
            :valorASerRateado="valorASerRateado"
            :valorRateado="valorRateado"
            :valorDisponivel="valorDisponivel"
            :percentualRateado="percentualRateado"
        ></quadro-resumo-rateios-edicao>
        <rateios
            :rateios="rateios"
            :valorASerRateado="valorASerRateado"
            :valorDisponivel="valorDisponivel"
            :operacao="operacao"
            :dataMovimento="dataComprometimento"
            :requisicao="requisicao"
        ></rateios>
        <div slot="modal-footer">
            <b-button
                variant="secondary"
                @click.stop="fecharModal()"
                class="mr-2"
                >Fechar</b-button
            >
        </div>
    </b-modal>
</template>

<script>
import QuadroResumoRateiosEdicao from './QuadroResumoRateiosEdicao'
import Rateios from './rateios/Rateios'

export default {
    props: {
        requisicao: {
            type: Object
        },

        titulo: {
            type: String,
            default: () => ''
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        operacao: {
            type: String,
            default: () => 'D'
        },

        comprometimento: {
            type: Object
        },

        dataServicos: {
            Object
        }
    },

    components: {
        QuadroResumoRateiosEdicao,
        Rateios
    },

    data() {
        return {
            mostrarModalLocal: false,
            rateios: [],
            historicoComprometimento: null,
            dataComprometimento: null,
            itensSelecionados: [],
            campos2: [
                {
                    key: 'idItemContrato',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Item do Contrato',
                    filterable: true
                },
                {
                    key: 'seqRm',
                    label: 'Seq RM',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'subTotal',
                    label: 'SubTotal',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'desconto',
                    label: 'Desconto',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'totalRateado',
                    label: 'Total Rateado',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'saldoASerRateado',
                    label: 'Saldo a Ser Rateado',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorRateado',
                    label: 'Valor Rateado',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        fecharModal() {
            this.rateios = []
            this.$emit('fecharModal')
        },

        preencherModal() {
            this.obterComprometimento()
        },

        obterComprometimento() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .obterComprometimento(
                    this.requisicao.idRequisicao,
                    this.comprometimento.idComprometimento
                )
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.historicoComprometimento =
                                response.data.historico
                            this.dataComprometimento = this.$moment(
                                response.data.dataMovimento
                            ).format('DD/MM/YYYY')
                            this.itensSelecionados = [...response.data.itens]
                            this.rateios = [...response.data.rateios]
                        } else {
                            this.$toast.error(
                                'Erro ao obter comprometimento',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        valorASerRateado() {
            return Number.parseFloat(
                this.itensSelecionados
                    .map((item) => {
                        return item.valorRateado
                    })
                    .reduce((a, b) => a + b, 0)
                    .toFixed(2)
            )
        },

        valorRateado() {
            return Number.parseFloat(
                this.rateios
                    .map((item) => {
                        return item.nuValorRateio
                    })
                    .reduce((a, b) => a + b, 0)
                    .toFixed(2)
            )
        },

        valorDisponivel() {
            return Number.parseFloat(
                (this.valorASerRateado - this.valorRateado).toFixed(2)
            )
        },

        percentualRateado() {
            return (this.valorRateado / this.valorASerRateado) * 100
        }
    },

    watch: {
        mostrarModal() {
            this.mostrarModalLocal = this.mostrarModal
        }
    }
}
</script>
